import React, { useEffect, useState, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../actions";
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ReportAPI } from '../../API/report'

import { REPORTS_URL } from '../../API/config'

//Charts
import { Pie } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { unoTheme } from '../../assets/styles/unoTheme';
import { getMonthName, applyMaskAmount, applyMaskCnpj, justNumbers, roundRect, getDayMonthYearByStringDate, getShortMonthName, getFirstPtDayMonth, getLastPtDayMonth, formatMillionNumber, getMonthAgo, getMonthAndYearBefore, dataToTableDistribuitionToReportTable, dataToChartDistribuitionToReportChart, getFirstAndEndDateByMonthAndYear } from '../utils/utils';

//Controllers
import {
    getDataToArticleReport,
    getDataToDistribuitionReport,
    getDataToPortfolioReport,
    getDataToTargetsReport,
    getDataToMyFundsReport,
    getDataToMyTitlesReport,
    getDataToDashboardReport,
    getDataToAprReport,
    getDataToBatchAprsReport,
    getDataToMyClientReturns,
    getDataToFundsRankingReport,
    getDataToSingleAprReport,
    getDataToDemonstrativeReport,
    getDataToProvisonalReport,
    getDataSuitabilityReport,
    getRawDataToTargetsReport,
    getDataToRentsByClassReport,
} from '../../controllers/ReportController';
import { getConsultingInfosById } from '../../API/consulting';
import { fundsTest } from '../main/administrative/fileTest';
import { reportTypes } from '../utils/ReportTypes';
import { formatPerformanceRuleToReport, formatRateToReport } from '../utils/costsUtils';
import { checkUserIsRole, roles } from '../utils/user';
import { RiskController } from '../../controllers/RiskController';
import moment from 'moment';
import { LegislationArticleAPI } from '../../API/legislation_article';

const NO_DATA = 'no_data';

const legendPieChartOpts = {
    display: false,
    fullWidth: true,
    reverse: false,
    labels: {
        padding: 20
    }
};

const modalWidths = {
    big: 'big',
    medium: 'medium',
    sm: 'sm'
};

//Plugin para deixar o background branco, melhora na resolução do pdf
const chartPlugins = [{
    id: 'custom_canvas_background_color',
    beforeDraw: (chart) => {
        const ctx = chart.canvas.getContext('2d');
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    }
}];

let optionsEvolutionChartDefault = {
    legend: {
        display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
        enabled: false
    },
    animation: {

        duration: 500,
        onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
            ctx.textAlign = 'center';
            ctx.fillStyle = "rgba(0, 0, 0, 1)";
            ctx.textBaseline = 'bottom';
            //ctx.font = '9.5px sans-serif'
            ctx.font = '10px sans-serif'
            // Loop through each data in the datasets
            this.data.datasets.forEach(function (dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach(function (bar, index) {
                    var data = dataset.data[index];

                    ctx.fillStyle = "rgba(255, 255, 255, 1)";
                    ctx.strokeStyle = "rgb(0, 0, 0)";

                    let text = applyMaskAmount(data.y, true);

                    let widthOfText = ctx.measureText(text).width + 10;

                    roundRect(ctx, bar._model.x - (widthOfText / 2), (chartInstance.chart.height / 2) - 20,
                        widthOfText, //width
                        25, //height
                        5, true, true);

                    ctx.fillStyle = "rgba(0, 0, 0, 1)";
                    ctx.fillText(text, bar._model.x, (chartInstance.chart.height / 2));
                    //ctx.fillText(applyMaskAmount(data.y, true), bar._model.x, bar._model.y - 1);
                });
            });
        }
    },
    scales: {
        yAxes: [{
            ticks: {
                //beginAtZero: true,

                max: 1000000000
            },

            display: false,
            gridLines: {
                display: true
            }
        }],
        xAxes: [{
            barPercentage: 0.5
        }]
    },

}

const optionsCompareChart = {
    legend: {
        display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
        enabled: false
    },
    animation: {
        duration: 500,
        onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
            console.log("CTX: ", ctx);
            //ctx.textAlign = 'center';
            ctx.fillStyle = "rgba(0, 0, 0, 1)";
            ctx.textBaseline = 'bottom';


            var mapPositions = [];
            var mapValuesLine = [];
            // Loop through each data in the datasets
            this.data.datasets.forEach(function (dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);


                meta.data.forEach(function (bar, index) {
                    var data = dataset.data[index];
                    //console.log("DATA COMPARE: ", data);

                    if (data && data.y != null) {

                        //ctx.fillText(applyMaskAmount(data.y) + "%", bar._model.x, bar._model.y + 20);
                        //ctx.fillRect(0, 0, bar._model.x, bar._model.y + 20);

                        //mapPositions.push(bar._model.y + 20);
                        console.log("INCLUINDO: ", data.y)
                        mapValuesLine.push(applyMaskAmount(data.y) + "%");
                    }
                    if (!data || data.y == null) {

                        //console.log("Bar model: ", bar._model.y);
                        ctx.fillStyle = "rgba(255, 255, 255, 1)";
                        ctx.strokeStyle = "rgb(0, 0, 0)";

                        const separator = '|';

                        const dataToShow = data ? applyMaskAmount(data) + "%" : '0,00%';

                        //let widthOfText = ctx.measureText(applyMaskAmount(data) + "%").width + 20;
                        //let widthOfText = ctx.measureText(applyMaskAmount(data) + "%" + separator + mapValuesLine[index]).width + 10;
                        let widthOfText = ctx.measureText(dataToShow + separator + mapValuesLine[index]).width + 12;

                        roundRect(ctx, bar._model.x - (widthOfText / 2), (chartInstance.chart.height / 2) - 20,
                            widthOfText, //width
                            25, //height
                            5, true, true);

                        //ctx.fillRect(bar._model.x - 45, bar._model.y + (115 - bar._model.y) - 18, 90, 20)

                        //ctx.fillRect(bar._model.x - 45, (chartInstance.chart.height / 2) - 20, widthOfText + 5, 30)

                        //ctx.fillStyle = "rgba(0, 0, 0, 1)";
                        ctx.fillStyle = "#000000";
                        //ctx.fillText(mapValuesLine[index] + " - " + applyMaskAmount(data) + "%", bar._model.x, (chartInstance.chart.height / 2));

                        ctx.textAlign = 'left';
                        ctx.fillStyle = unoTheme.chartColors[0];
                        ctx.fillText(dataToShow, bar._model.x + 2.5, (chartInstance.chart.height / 2));
                        ctx.textAlign = 'center';
                        ctx.fillStyle = "#000000";
                        ctx.fillText(separator, bar._model.x, (chartInstance.chart.height / 2));
                        ctx.textAlign = 'right';
                        ctx.fillStyle = unoTheme.chartColors[1];
                        ctx.fillText(mapValuesLine[index], bar._model.x - 2.5, (chartInstance.chart.height / 2));

                        //ctx.fillRect(bar._model.x - 10, bar._model.x + 10, bar._model.y + (115 - bar._model.y) - 10, bar._model.y + (115 - bar._model.y) + 10);


                    }

                });

            });

            console.log("Map position: ", mapPositions);
        }
    },
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            },
            display: false,
            gridLines: {
                display: true
            }
        }],
        xAxes: [{
            barPercentage: 0.5
        }]
    }
};

const optionsChartRentsMonthCompareFunds = {
    // title: {
    //     display: true,
    //     text: 'Polveri',
    //     fontSize: 18
    // },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
    scales: {
        yAxes: [{
            ticks: {
                // Include a dollar sign in the ticks
                callback: function (value, index, values) {
                    //return applyMaskAmount(value, true);
                    // return formatMillionNumber(value);
                    return value + '%';
                }
            }
        }],
    },

    tooltips: {
        callbacks: {
            label: function (tooltipItem) {
                return applyMaskAmount(tooltipItem.yLabel) + '%';
            }
        }
    },

}

const optionsChartPlEvolutionCompareFunds = {
    // title: {
    //     display: true,
    //     text: 'Polveri',
    //     fontSize: 18
    // },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true,
                // Include a dollar sign in the ticks
                callback: function (value, index, values) {
                    //return applyMaskAmount(value, true);
                    // return formatMillionNumber(value);
                    return formatMillionNumber(value);
                }
            }
        }],
    },

    tooltips: {
        callbacks: {
            label: function (tooltipItem) {
                return applyMaskAmount(tooltipItem.yLabel, true);
            }
        }
    },

}

const DEFAULT_MODAL_WIDTH = modalWidths.medium;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(5),
    },

    progressAndMessage: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: theme.spacing(2),

        '& .MuiCircularProgress-root': {
            width: '20px !important',
            height: '20px !important',
            color: unoTheme.mainColor,
            marginRight: theme.spacing(2),
        }
    },

    displayChart: {

    },

    displayChartCompareFunds: {
        height: '330px',
    }
}));

export default function ReportLoadModal(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const reportLoad = useSelector(state => state.reportLoad)

    //Distribuition
    const [dataToDistribuitionChart, setDataToDistribuitionChart] = useState(undefined);

    const chartDistribuitionRef = useRef(null);

    //Dashboard
    const [dataToEvolutionPlChart, setDataToEvolutionPlChart] = useState(undefined);
    const [optionsEvolutionChart, setOptionsEvolutionChart] = useState(undefined);
    const [dataToCompareChart, setDataToCompareChart] = useState(undefined);

    const [dataToRentsMonthCompareFundsChart, setDataToRentsMonthCompareFundsChart] = useState(undefined);
    const [dataToPlEvolutionCompareFundsChart, setDataToPlEvolutionCompareFundsChart] = useState(undefined);

    const chartEvolutionPlRef = useRef(null);
    const chartCompareRef = useRef(null);
    const chartRentsMonthCompareFundsRef = useRef(null);
    const chartPlEvolutionCompareFundsRef = useRef(null);

    const [modalWidth, setModalWidth] = useState(DEFAULT_MODAL_WIDTH);
    const [innerReportLoadMessage, setInnerReportLoadMessage] = useState();

    function getMonthsPeriod(startDate, endDate) {
        const responseStart = getDayMonthYearByStringDate(startDate);
        const responseEnd = getDayMonthYearByStringDate(endDate);

        const monthsPeriod = [];

        if (responseEnd.month - responseStart.month == 2) { //Quarter
            for (let index = responseStart.month; index <= responseEnd.month; index++) {
                monthsPeriod.push(getShortMonthName(index));
            }
        } else if (responseEnd.month - responseStart.month == 5) { //Semester
            if (responseEnd.month == 6) {
                monthsPeriod.push('1º Tri.')
                monthsPeriod.push('2º Tri.')
                monthsPeriod.push('1º Semestre')
            } else {
                monthsPeriod.push('3º Trim.')
                monthsPeriod.push('4º Tri.')
                monthsPeriod.push('2º Semestre')
            }
        }

        return monthsPeriod;
    }

    function getPeriodStringReport(startDate, endDate, periodReport) {


        console.log('getPeriodStringReport: ', startDate);
        console.log('getPeriodStringReport: ', endDate);
        const responseStartDateMonthYear = getDayMonthYearByStringDate(startDate);
        const { month, year } = getDayMonthYearByStringDate(endDate);

        if (periodReport == "since_beginning" || periodReport == "free") {
            const start = `${getMonthName(responseStartDateMonthYear.month)} de ${responseStartDateMonthYear.year}`;
            const end = `${getMonthName(month)} de ${year}`;
            return `${start} a ${end}`;
        }

        if (responseStartDateMonthYear.month == month && responseStartDateMonthYear.year == year) {
            //isMonthly
            return getMonthName(month) + "/" + year;
        } else {
            return getMonthName(responseStartDateMonthYear.month) + " a " + getMonthName(month) + " de " + year;
        }

    }

    // showZero=false (padrão): valores 0 exibem "-". Passar showZero=true apenas para
    // Tx. Adm, que deve sempre exibir o valor (mesmo alinhamento da CostsScreen).
    function formatPercentToReport(value, showZero = false) {
        if (value === null || value === undefined || value === '' || value === '-') return '-';
        const num = parseFloat(String(value).replace(',', '.'));
        if (isNaN(num)) return '-';
        if (num === 0 && !showZero) return '-';
        return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
    }

    /**
   * @param {import('../../API/report').DataToReportAPI} data Dados do gráfico formatados para a biblioteca Chart.js.
   * @param {import('../../API/report').ReportTypeAPI} reportType Tipo de relatório.
   * @param {string} fileName
   * @param {number} count Contagem para nomeação de imagens do gráfico.
   * @param {import('chart.js').ChartLegendOptions} legend
   */
    async function saveChartImageToReport(
        data,
        reportType,
        fileName,
        count,
        legend
    ) {
        return ReportAPI.saveChartTmpImage(
            clientOn.client.id,
            data,
            count,
            fileName,
            reportType,
            legend
        );
    }

    async function deprecatedSaveChartImageToReport(chartRef, index, fileName) {
        const base64Image = chartRef.current.chartInstance.toBase64Image();

        let response = await ReportAPI.deprecatedSaveChartTmpImage(
            clientOn.client.id,
            base64Image,
            index,
            fileName
        );

        if (response.success) {
            return {
                success: true,
            };
        } else {
            console.error("Falha ao salvar a imagem do report");
        }
    }

    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    //Necessário pra dar uma margem no gráfico a ser desenhado, possibilitando escrever valor por cima da coluna
    function getOptionsToEvolutionChart(maxValue, numLabels) {

        console.log("MAX VALUE: ", maxValue)
        if (maxValue < 1000000) {

            maxValue += 200000;

        } else if (maxValue >= 10000000 && maxValue < 100000000) {

            maxValue += 5000000;

        } else if (maxValue >= 100000000) {

            maxValue += 10000000;

        }

        optionsEvolutionChartDefault.scales.yAxes[0].ticks.max = maxValue;

        console.log("NUM LABELS: ", numLabels);
        console.log("NUM LABELS: ", optionsEvolutionChartDefault.scales.yAxes[0].ticks);
        if (numLabels <= 6) {
            optionsEvolutionChartDefault.scales.yAxes[0].ticks.beginAtZero = true;
        }

        return optionsEvolutionChartDefault;

    }

    // async function prepareChartsAndGenerate() {

    //     const finalPath = await getFullReportPath(null, null, reportLoad.reportTypeList);

    //     openReport(finalPath);

    // }

    /**
  * @typedef {import ("../../actions/reportLoadActions").ReportLoadObj & {
  *    startDate: string;
    *    endDate: string;
    * }} ConfigReport
    * @param {ConfigReport} configReport
    */
    async function prepareChartsAndGenerate(configReport) {

        let { startDate, endDate, periodReport, reportTypeList } = configReport;

        //Obtendo informações da consultoria
        const consultingInfos = await getConsultingInfosById(
            currentUser.user.consulting_id
        );
        console.log("consultingInfos: ", consultingInfos);
        clientOn.client.consultingName = consultingInfos
            ? consultingInfos.short_name
            : "LEMA";

        //Chamadas de report nas telas, deve executar como report mensal para o mês selecionado
        if (!startDate && !endDate) {
            startDate = getFirstPtDayMonth(clientOn.client.selectedPortfolioMonth,
                clientOn.client.selectedPortfolioYear);
            endDate = getLastPtDayMonth(clientOn.client.selectedPortfolioMonth,
                clientOn.client.selectedPortfolioYear);

            periodReport = 'mensal';
        }

        console.log("startDate: ", startDate);
        console.log("endDate: ", endDate);

        setModalWidth(DEFAULT_MODAL_WIDTH);

        //Variáveis utilizadas no caso do full report
        let dataDistribuition = null;
        let dataDashboard = null;

        const isReportTypeFullReport = reportLoad.reportType == 'fullReport';
        const isReportTypeDistribution = reportLoad.reportType == 'distribuition';
        const isReportTypeSummarised = reportLoad.reportType == 'dashboard';
        const isReportTypeCustomWithDistribuition = reportTypeList && reportTypeList.includes('distribuition');
        const isReportTypeCustomWithDashboard = reportTypeList && reportTypeList.includes('dashboard');
        const isReportTypeCompareFunds = reportLoad.reportType == 'compareFunds';
        const isReportSegregation = reportLoad.reportType == 'segregation';
        //const periodReport = reportLoad.periodReport;

        if (isReportTypeFullReport || isReportTypeDistribution || isReportSegregation) {
            setInnerReportLoadMessage("Gerando relatório de distribuição...");
        }

        if (
            isReportTypeDistribution ||
            isReportTypeFullReport ||
            isReportTypeCustomWithDistribuition ||
            isReportSegregation
        ) {
            //Relatório de distribuição necessita de um gráfico que é previamente redenrizado,
            //fotografado e enviado para o servidor para ser usado no relatório

            let responseDataToReport = await getDataToDistribuitionReport(
                clientOn.client.id,
                startDate,
                endDate,
                reportLoad.segregationSelected ? reportLoad.segregationSelected.value : null
            );

            /**
             * @type {import('../../controllers/ReportController').DataToReport['dataToTable']}
             */
            let dataToTables = [];
            for (
                let i = 0;
                i < responseDataToReport.dataToDistributionReport.length;
                i++
            ) {
                const count = i + 1;
                let dataLoop = responseDataToReport.dataToDistributionReport[i];

                dataToTables.push(dataLoop["dataToTable"]);

                /**
                 * @type {import('../../API/report').DataToReportAPI}
                 */
                const dataToChart = {
                    chart: dataLoop.dataToChart,
                };

                console.log("dataToChart yyy: ", dataToChart);
                await saveChartImageToReport(
                    dataToChart,
                    'distribuition',
                    'chartDistribution',
                    count,
                    legendPieChartOpts
                );
            }

            console.log("dataToTables distribuition: ", dataToTables);
            dataDistribuition = dataToTables;
        }

        if (isReportTypeFullReport) {
            setInnerReportLoadMessage("Gerando relatório de evolução do patrimônio...");
        }

        //Gerando gráficos para dashboard report
        if (isReportTypeSummarised || isReportTypeFullReport || isReportTypeCustomWithDashboard) {
            let responseDataToReport = await getDataToDashboardReport(clientOn.client.id,
                startDate, endDate, periodReport, clientOn.client.portfolio_init);

            if (responseDataToReport.success) {
                /**
                 * @type {import('../../API/report').DataToReportAPI}
                 */
                const dataToChartEvolution = {
                    chart: responseDataToReport.dataToChartEvolution,
                    maxValue: responseDataToReport.maxValue,
                };

                await saveChartImageToReport(
                    dataToChartEvolution,
                    "plEvolution",
                    "chartEvolutionPl"
                );

                if (isReportTypeFullReport) {
                    setInnerReportLoadMessage("Gerando relatório comparativo...");
                }

                /** @type {import('../../API/report').DataToReportAPI} */
                const dataChartComparative = {
                    chart: responseDataToReport.dataToChartCompare,
                };
                await saveChartImageToReport(
                    dataChartComparative,
                    "comparative",
                    "chartCompare"
                );

                dataDashboard = responseDataToReport.dataToReport;
            }
        }

        //Comparador de Fundos
        if (isReportTypeCompareFunds) {
            setModalWidth(modalWidths.big);

            const { chartRentsMonthData, chartPlEvolutionData, tableData } =
                reportLoad;
            setDataToRentsMonthCompareFundsChart(chartRentsMonthData);

            //Tempo necessário para o gráfico ser renderizado na tela e ser possível fotografá-lo pela referência
            await timeout(800);
            const nameResponseSaveImg1 = "chartRentsMonthCompareFunds";
            const responseSaveImg1 = await deprecatedSaveChartImageToReport(
                chartRentsMonthCompareFundsRef,
                null,
                nameResponseSaveImg1
            );
            setDataToRentsMonthCompareFundsChart(null);

            await timeout(200);
            setDataToPlEvolutionCompareFundsChart(chartPlEvolutionData);
            await timeout(800);
            const nameResponseSaveImg2 = "chartPlEvolutionCompareFunds";
            const responseSaveImg2 = await deprecatedSaveChartImageToReport(chartPlEvolutionCompareFundsRef, null, nameResponseSaveImg2);

            await timeout(200);
            setDataToPlEvolutionCompareFundsChart(null);
        }

        setModalWidth(DEFAULT_MODAL_WIDTH);

        setInnerReportLoadMessage("Gerando relatório...");

        //Comparador de Fundos
        if (isReportTypeCompareFunds) {
            let pathToReport = await getCompareFundsReportPath(reportLoad.fundsInCompare, reportLoad.benchamrksInCompare, reportLoad.tableData, reportLoad.returnsTableData);
            console.log('pathToReport: ', pathToReport);
            if (pathToReport != null) {
                openReport(pathToReport);
            }
        } else {
            let pathToReport = await getPathToReport(dataDashboard, dataDistribuition, startDate, endDate, periodReport, reportTypeList, reportLoad.reportData);
            if (pathToReport != null) {
                openReport(pathToReport);
            }
        }

        setInnerReportLoadMessage();
    }

    async function getCapaFileNameIfNecessary(referenceDate, reportCapaTitle) {
        if (!reportCapaTitle) return null;
        const capaFileName = await getCapaReportPath(referenceDate, referenceDate, reportCapaTitle);
        return capaFileName;
    }

    async function getPathToReport(...data) {


        const [
            dataDashboard,
            dataDistribuition,
            startDate,
            endDate,
            periodReport,
            reportTypeList,
            reportData, //ipc14
        ] = data;

        console.log("data getPathToReport: ", data);
        console.log("START DATE getPathToReport: ", startDate);
        console.log("END DATE getPathToReport: ", endDate);
        console.log("reportLoad.reportType: ", reportLoad.reportType);

        let finalPath = null;

        switch (reportLoad.reportType) {
            case 'portfolio':
                finalPath = await getPortfolioReportPath(reportLoad.accountRegimeId, startDate, endDate, periodReport, {}, "CARTEIRA"); //Adicionando parâmetro de accountRegimeId
                break;
            case 'assetsAndAccounts':
                finalPath = await getPortfolioReportPath(reportLoad.accountRegimeId, startDate, endDate, periodReport, {
                    isAssetAndAccountsReport: true,
                }, "ATIVOS E CONTAS");
                break;
            case 'transactionsInPeriod':
                finalPath = await getPortfolioReportPath(reportLoad.accountRegimeId, startDate, endDate, periodReport, {
                    isAccumulatedTrasactionsReport: true,
                }, "MOVIMENTAÇÕES NO PERÍODO");
                break;
            case 'provisional':
                finalPath = await getProvisionalReportPath(startDate, endDate, periodReport); //Adicionando parâmetro de accountRegimeId
                break;
            case 'dashboard':
                finalPath = await getDashboardReportPath(dataDashboard, startDate, endDate, "DASHBOARD");
                break;
            case 'distribuition':
                finalPath = await getDistribuitionReportPath(dataDistribuition, startDate, endDate,
                    reportLoad.segregationSelected && reportLoad.segregationSelected.value
                        ? "DISTRIBUIÇÃO (" + reportLoad.segregationSelected.name.toUpperCase() + ")"
                        : "DISTRIBUIÇÃO");
                break;
            case 'articles':
                finalPath = await getArticlesReportPath(startDate, endDate, "ENQUADRAMENTOS");
                break;
            case 'targets':
                finalPath = await getTargetsReportPath(startDate, endDate, periodReport, "METAS", reportLoad.segregationCode != null ? reportLoad.segregationCode : 0);
                break;
            case 'myFunds':
                finalPath = await getMyFundsReportPath(startDate, endDate, periodReport, "ANÁLISE DE FUNDOS");
                break;
            case 'myTitles':
                finalPath = await getMyTitlesReportPath(startDate, endDate, "ANÁLISE DE TÍTULOS");
                break;
            case 'rentsByClass':
                finalPath = await getRentsByClassReportPath(startDate, endDate, periodReport, "RENTABILIDADES POR CLASSE");
                break;
            case 'myReturns':
                finalPath = await getMyReturnsReportPath(startDate, endDate, "RETORNOS DIÁRIOS");
                break;
            case 'myGlobalReturns':
                finalPath = await getMyGlobalReturnsReportPath(startDate, endDate, "RETORNOS GLOBAIS");
                break;
            case 'myReturnsByAssets':
                finalPath = await getMyReturnsByAssetsReportPath(startDate, endDate, reportLoad.reportData, "RETORNOS POR ATIVO");
                break;
            case 'myReturnsByArticles':
                finalPath = await getMyReturnsByArticlesReportPath(startDate, endDate, reportLoad.reportData, "RETORNOS POR ENQUADRAMENTO");
                break;
            case 'myReturnsBySegregation':
                finalPath = await getMyReturnsBySegregationReportPath(startDate, endDate, reportLoad.reportData, "RETORNOS POR SEGREGAÇÃO");
                break;
            case 'benchmarkIndexes':
                finalPath = await getBenchmarkIndexesReportPath(startDate, endDate, reportLoad.reportData, "ÍNDICES DE REFERÊNCIA");
                break;
            case 'clientSuitability':
                finalPath = await getClientSuitabilityReportPath(reportLoad.selectedClient, reportLoad.suitabilityResponses);
                break;
            case 'segregation':
                finalPath = await getSegregationReportPath(reportLoad.segregationSelected, dataDistribuition, startDate, endDate, periodReport);
                break;
            case 'accreditationProcesses':
                //finalPath = await getClientAccreditationProcessesReportPath(reportLoad.reportData, "PROCESSOS DE CREDENCIAMENTO");
                finalPath = await getClientAccreditationProcessesReportPath(reportLoad.reportData);
                break;
            case 'custom':
            case 'fullReport':
                finalPath = await getFullReportPath(dataDashboard,
                    dataDistribuition,
                    reportTypeList,
                    startDate,
                    endDate,
                    periodReport, reportLoad.reportType == "custom");
                break;
            case 'apr':
                finalPath = await getAprReportPath();
                break;
            case 'singleApr':
                finalPath = await getSingleAprReportPath();
                break;
            case 'batchAprs':
                finalPath = await getBatchAprsReportPath();
                break;
            case 'fundsRanking':
                finalPath = await getFundsRankingReportPath(reportLoad.reportData);
                break;
            case 'demonstrative':
                finalPath = await getDemonstrativeReportPath(startDate, endDate, reportLoad.reportData, "DEMONSTRATIVO");
                break;
            case 'risk':
                finalPath = await getRiskReportPath(startDate, endDate);
                break;
            case 'ipc14_returns':
                finalPath = await getIPC14ReturnsReportPath(reportData);
                break;
            case 'loss_provision':
                finalPath = await getLossProvisionReportPath(reportData);
                break;
            case 'bladeFund':
                finalPath = await getBladeFundReportPath(reportLoad.data, reportLoad.referenceDate, reportLoad.dataReturnsChart, reportLoad.dataPlChart);
                break;
            case 'alocation':
                finalPath = await getAlocationReportPath(reportData, reportLoad.referenceDate);
                break;
            case 'curveXMarket':
                finalPath = await getCurveXMarketReportPath(reportData, endDate, "RETORNOS DE TÍTULOS PÚBLICOS CURVA X MERCADO");
                break;
            case 'costs':
                finalPath = await getCostsReportPath(startDate, endDate);
                break;
            case 'alm':
                finalPath = await getAlmReportPath(startDate, endDate);
                break;
        }
        return finalPath;
    }

    function openReport(pathToReport) {


        const href = REPORTS_URL + 'reports/'
            + clientOn.client.id + pathToReport;

        Object.assign(document.createElement('a'), {
            target: '_blank', href
        }
        ).click();

        dispatch(allActions.reportLoadActions.setReportLoad(null))

    }

    async function getCurveXMarketReportPath(data, endDate, reportCapaTitle) {
        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);

        //Período da tela; "Desde o início" atravessa anos e precisa do formato com ano nas duas pontas
        const period = (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
            getPeriodStringReport(reportLoad.startDate, reportLoad.endDate,
                reportLoad.periodType === 'fromStart' ? 'since_beginning' : null);

        let responseReport = await ReportAPI.getCurveXMarketReport(data, capaFileName, period);

        if (responseReport.success) {

            return responseReport.body.data.pathToReport;

        } else {

            return false;

        }
    }

    async function getCostsReportPath(startDate, endDate) {
        const period = getPeriodStringReport(startDate, endDate);
        const raw = reportLoad.reportData;

        const data = {
            //As taxas vêm já normalizadas da CostsScreen (bloco `rates`), com o estado
            //semântico resolvido. O PDF apenas traduz o estado para sigla, para não repetir
            //aqui a decisão de "informado / não informado / não aplicável".
            funds: (raw.funds || []).map(f => ({
                fund_name: f.fund_name,
                cnpj: f.cnpj,
                max_administration_tax: formatRateToReport(f.rates && f.rates.global),
                administration_tax: formatRateToReport(f.rates && f.rates.administration),
                management_tax: formatRateToReport(f.rates && f.rates.management),
                distribution_tax: formatRateToReport(f.rates && f.rates.distribution),
                custody_tax: formatRateToReport(f.rates && f.rates.custody),
                performance_tax: formatRateToReport(f.rates && f.rates.performance),
                performance_rule: formatPerformanceRuleToReport(f.performanceRule),
            })),
            institutions: (raw.institutions || []).map(i => ({
                instituition_name: i.instituition_name || '-',
                cnpj: i.cnpj || '-',
                custody_rate: formatPercentToReport(i.custody_rate),
                brokerage_rate: formatPercentToReport(i.brokerage_rate),
            })),
            otherCosts: (raw.otherCosts || []).map(c => ({
                description: c.description,
                monthly_value: applyMaskAmount(c.monthly_value, true),
                months: c.months,
                total: applyMaskAmount(c.total, true),
            })),
        };

        const responseReport = await ReportAPI.getCostsReport(clientOn.client, period, data);
        if (responseReport.success) return responseReport.body.data.pathToReport;
        return false;
    }

    async function getAlmReportPath(startDate, endDate) {

        const period = getPeriodStringReport(startDate, endDate);
        const raw = reportLoad.reportData || {};

        const data = {
            rows: (raw.rows || []).map(r => ({
                benchmarkName: r.benchmarkName,
                atual: formatPercentToReport(r.atual),
                sugestion: formatPercentToReport(r.alm_sugestion),
                gap: formatPercentToReport(r.gap),
            })),
            total: {
                atual: formatPercentToReport(raw.total ? raw.total.atual : 100),
                sugestion: formatPercentToReport(raw.total ? raw.total.sugestion : 0),
                gap: formatPercentToReport(raw.total ? raw.total.gap : 0),
            },
        };

        const responseReport = await ReportAPI.getAlmReport(clientOn.client, period, data);
        if (responseReport.success) return responseReport.body.data.pathToReport;
        return false;
    }

    async function getPortfolioReportPath(accountRegimeId, startDate, endDate, periodReport,
        {
            isAssetAndAccountsReport = false,
            isAccumulatedTrasactionsReport = false
        } = {}, reportCapaTitle) {

        let responseDataToReport = await getDataToPortfolioReport(clientOn.client.id,
            startDate,
            endDate,
            accountRegimeId, periodReport, {
            isAssetAndAccountsReport,
            isAccumulatedTrasactionsReport
        });

        console.log("reportCapaTitlereportCapaTitle: ", reportCapaTitle);
        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
        console.log("capaFileNamecapaFileName: ", capaFileName);

        const { monthBefore, yearBefore } = getMonthAndYearBefore(startDate);
        let responseReport = await
            ReportAPI.getPortfolioReport(
                clientOn.client,
                (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
                getPeriodStringReport(startDate, endDate, periodReport),
                {
                    data: responseDataToReport.dataToPortfolioReport,
                    executiveSummary: responseDataToReport.executiveSummary
                },
                {
                    isAssetAndAccountsReport,
                    isAccumulatedTrasactionsReport,
                    startDate: getLastPtDayMonth(monthBefore, yearBefore),
                    endDate,
                }, capaFileName
            );

        if (responseReport.success) {

            return responseReport.body.data.pathToReport;

        } else {

            return false;

        }

    }

    async function getProvisionalReportPath(startDate, endDate, periodReport) {

        const responseDataToReport = await getDataToProvisonalReport(clientOn.client.id,
            startDate,
            endDate);

        if (!responseDataToReport || !responseDataToReport.success) {

            console.error("FALHA AO OBTER OS DADOS DO RELATÓRIO PROVISÓRIO: ", responseDataToReport);
            dispatch(allActions.reportLoadActions.setReportLoad(null))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: responseDataToReport && responseDataToReport.message
                    ? responseDataToReport.message
                    : "Falha ao obter os dados do relatório provisório",
                type: 'error',
            }))

            return null;
        }

        //Títulos que não puderam ser projetados entram no relatório com o saldo do mês anterior,
        //então o usuário precisa saber quais foram para conferir o total
        const unprojectedTitles = responseDataToReport.unprojectedTitles || [];
        if (unprojectedTitles.length) {

            console.warn("TÍTULOS SEM PROJEÇÃO NO RELATÓRIO PROVISÓRIO: ", unprojectedTitles);
            const MAX_TITLES_IN_ALERT = 5;
            const listedTitles = unprojectedTitles.slice(0, MAX_TITLES_IN_ALERT).map(el => el.titleCod).join(', ');
            const remainingTitles = unprojectedTitles.length - MAX_TITLES_IN_ALERT;
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: `${unprojectedTitles.length} título(s) sem projeção no período (saldo do mês anterior mantido): ${listedTitles}${remainingTitles > 0 ? ` e outros ${remainingTitles}` : ''}. Detalhes no console.`,
                type: 'warning',
            }))
        }

        const promises = [];
        //Adicionando capa ao relatório provisório
        promises.push(
            new Promise(async (resolve, reject) => {
                let path = await getCapaReportPath(startDate, endDate, "RELATÓRIO PROVISÓRIO");

                if (path) {

                    resolve({
                        path,
                        index: 0,
                    });

                } else {

                    resolve(false);

                }
            })
        )

        promises.push(
            new Promise(async (resolve, reject) => {
                const response = await
                    ReportAPI.getProvisionalReport(clientOn.client, 'Cota referência: ' + responseDataToReport.referenceQuotaDate + ' - ' + getPeriodStringReport(startDate, endDate),
                        responseDataToReport.dataToReport, 1);

                if (response.success) {

                    resolve({
                        path: response.body.data.pathToReport,
                        index: 1,
                    });

                } else {

                    resolve(false);

                }
            })
        )

        const responseAll = await Promise.all(promises);
        let pathsToSend = [];

        console.log('responseAll: ', responseAll);

        if ((responseAll.filter(el => !el)).length == 0) {

            for (let i = 0; i < responseAll.length; i++) {

                if (responseAll[i] != NO_DATA) {//removendo os que não possuem dados, como no caso em que não há títulos

                    pathsToSend.push(responseAll[i].path);

                }

            }

            const responseProvisionalReport = await ReportAPI.getFullReport(clientOn.client, pathsToSend, "RELATORIO_PROVISORIO");

            if (responseProvisionalReport.success) {
                return responseProvisionalReport.body.data.pathToReport
            } else {
                return false;
            }
        }

    }

    async function getCapaReportPath(startDate, endDate, title, periodReport, subTitle) {

        const period = getPeriodStringReport(startDate, endDate, periodReport);
        const responseCapaReport = await ReportAPI.getCapaReport(
            clientOn.client,
            period, title, subTitle);

        if (responseCapaReport.success) {

            console.log("Path to capa: ", responseCapaReport.body.data.pathToReport);
            return responseCapaReport.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getDashboardReportPath(data, startDate, endDate, reportCapaTitle) {

        const period = getPeriodStringReport(startDate, endDate);

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);

        let responseDashboardReport = await ReportAPI.getDashboardReport(
            clientOn.client,
            period,
            data, capaFileName);

        if (responseDashboardReport.success) {

            return responseDashboardReport.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getRiskReportPath(startDate, endDate) {

        const promises = [];
        const period = getPeriodStringReport(startDate, endDate);

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            updateMessage: true,
            message: 'Gerando relatório de risco... ( 1/4 )'
        }))

        const responseResolution = await LegislationArticleAPI.getResolutionVersionIdByDate(endDate);
        const resolutionName = responseResolution.body.rows[0].resolution_name;

        //As quatro seções são geradas de uma vez no servidor (ou lidas do cache)
        const riskData = await RiskController.getRiskData(clientOn.client.id, endDate);

        //Market
        const dataMarket = riskData ? riskData.market : null;
        promises.push(new Promise(async (resolve, reject) => {
            const responsePart = await ReportAPI.getRiskMarketReport(clientOn.client,
                period,
                dataMarket, resolutionName);

            if (responsePart.success) {

                console.log("getMarketData OKX");
                resolve(responsePart.body.data.pathToReport);

            } else {

                console.log("ERRO AO TRAZER PATH");
                resolve(false);

            }
        }))

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            updateMessage: true,
            message: 'Gerando relatório de risco... ( 2/4 )'
        }))


        //Articles
        //Seção liberada apenas para uso interno enquanto a adequação
        //à resolução 5.272 está em validação
        if (checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor])) {

            const dataArticles = riskData ? riskData.articles : null;
            promises.push(new Promise(async (resolve, reject) => {
                const responsePart = await ReportAPI.getRiskArticlesReport(clientOn.client,
                    period,
                    dataArticles,
                    undefined,
                    endDate);

                if (responsePart.success) {

                    console.log("getArticlesData OKX");
                    resolve(responsePart.body.data.pathToReport);

                } else {

                    console.log("ERRO AO TRAZER PATH");
                    resolve(false);

                }
            }))
        }

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            updateMessage: true,
            message: 'Gerando relatório de risco... ( 3/4 )'
        }))

        //Benchmarks
        const dataBenchmarks = riskData ? riskData.benchmarks : null;
        promises.push(new Promise(async (resolve, reject) => {
            const responsePart = await ReportAPI.getRiskBenchmarksReport(clientOn.client,
                period,
                dataBenchmarks);

            if (responsePart.success) {

                console.log("getBenchmarksData OKX");
                resolve(responsePart.body.data.pathToReport);

            } else {

                console.log("ERRO AO TRAZER PATH");
                resolve(false);

            }
        }))

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            updateMessage: true,
            message: 'Gerando relatório de risco... ( 4/4 )'
        }))

        //Policy
        const dataPolicy = riskData ? riskData.policy : null;
        promises.push(new Promise(async (resolve, reject) => {
            const responsePart = await ReportAPI.getRiskPolicyReport(clientOn.client,
                period,
                dataPolicy, resolutionName);

            if (responsePart.success) {

                console.log("getPolicyData OKX");
                resolve(responsePart.body.data.pathToReport);

            } else {

                console.log("ERRO AO TRAZER PATH");
                resolve(false);

            }
        }))

        const responseParts = await Promise.all(promises)

        //return responseParts[0];

        const responseReportFull = await
            ReportAPI.getFullRiskReport(clientOn.client, responseParts, resolutionName);

        if (responseReportFull.success) {

            return responseReportFull.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getIPC14ReturnsReportPath(data) {

        const response = await ReportAPI.getIPC14ReturnsReport(clientOn.client, data);

        if (response.success) {

            return response.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getLossProvisionReportPath(data) {

        const response = await ReportAPI.getLossProvisionReport(clientOn.client, data);

        if (response.success) {

            return response.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getBladeFundReportPath(data, referenceDate, dataReturnsChart, dataPlChart) {

        const fileNameReturnsReport = "bladeReturnsChart_" + new Date().getTime();
        const fileNamePlReport = "bladePlChart_" + new Date().getTime();
        const dataToReturnsChart = {
            chart: dataReturnsChart.data
        };

        await saveChartImageToReport(
            dataToReturnsChart,
            "bladeFundReturns",
            fileNameReturnsReport
        );

        const dataToPlChart = {
            chart: dataPlChart.data
        };

        await saveChartImageToReport(
            dataToPlChart,
            "bladeFundPl",
            fileNamePlReport
        );

        const response = await ReportAPI.getBladeFundReport(clientOn.client,
            data,
            referenceDate, fileNameReturnsReport, fileNamePlReport);

        if (response.success) {

            return response.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getAlocationReportPath(data, referenceDate) {

        const {
            distribuition: {
                dataToChart,
                dataToTable
            }
        } = data;

        const capaFileName = await getCapaReportPath(referenceDate, referenceDate, "SUGESTÃO DE ALOCAÇÃO");
        const fileNameBenchmarkReport = "alocationBenchmarkChart_" + new Date().getTime();

        const responseDataToPieChartReport = dataToChartDistribuitionToReportChart(dataToChart);
        const dataToBenchmarkChart = {
            chart: responseDataToPieChartReport
        };

        console.log("dataToBenchmarkChart: ", dataToBenchmarkChart)

        await saveChartImageToReport(
            dataToBenchmarkChart,
            "distribuition",
            fileNameBenchmarkReport
        );

        const responseDataToTableReport = dataToTableDistribuitionToReportTable(dataToTable);
        data.dataToTableReportBenchmarks = responseDataToTableReport;

        const response = await ReportAPI.getAlocationReport(clientOn.client,
            capaFileName,
            data,
            referenceDate, fileNameBenchmarkReport);

        if (response.success) {

            return response.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getDistribuitionReportPath(data, startDate, endDate, reportCapaTitle) {

        console.log("START DATE: ", startDate);
        console.log("END DATE: ", endDate);
        const period = getPeriodStringReport(startDate, endDate);

        //Temporário
        let pageIndex = 1;

        //Verificando se os dados das duas primeiras distribuições podem ser agrupados numa mesma página
        const limitLines = 8;
        let group12 = false;
        if (data[0].data.length <= limitLines
            && data[1].data.length <= limitLines) {
            group12 = true;
        }
        //Verificando se os dados da terceira e da quarta distribuição podem ser agrupados numa mesma página
        let group34 = false;
        if (data[2].data.length <= limitLines
            && data[3].data.length <= limitLines) {
            group34 = true;
        }

        let responseParts = null;

        console.log('group12: ', group12);
        console.log('group34: ', group34);
        if (!group12 && !group34) {
            responseParts = await Promise.all(

                data.map(async (part, index) => {

                    let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                        period,
                        part, index + 1, pageIndex + index);

                    if (responsePart.success) {

                        return responsePart.body.data.pathToReport;

                    } else {

                        console.log("ERRO AO TRAZER PATH");
                        return false;

                    }

                })

            )
        } else if (group12 && !group34) { //agrupar os dois primeiros e não agrupar o 3 e o 4

            let promises = [];

            promises.push(new Promise(async (resolve, reject) => {
                let responsePart = await ReportAPI.getDistribuitionReportPartGrouped(clientOn.client,
                    period,
                    data[0],
                    data[1],
                    1, 2, pageIndex);

                if (responsePart.success) {

                    resolve(responsePart.body.data.pathToReport);

                } else {

                    console.log("ERRO AO TRAZER PATH");
                    resolve(false);

                }
            }))

            pageIndex++;

            let newData = data.slice(2);
            newData.map(async (part, index) => {

                promises.push(
                    new Promise(async (resolve, reject) => {
                        let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                            period,
                            part, index + 3, pageIndex + index);

                        if (responsePart.success) {

                            resolve(responsePart.body.data.pathToReport);

                        } else {
                            resolve(false);
                        }
                    })
                )

            })

            responseParts = await Promise.all(promises)

        } else if (group12 && group34) { //Agrupar os dois primeiros, e o terceiro com o quarto

            let promises = [];

            promises.push(new Promise(async (resolve, reject) => {
                let responsePart = await ReportAPI.getDistribuitionReportPartGrouped(clientOn.client,
                    period,
                    data[0],
                    data[1],
                    1, 2, pageIndex);

                if (responsePart.success) {

                    console.log("Resolvido 12");

                    resolve(responsePart.body.data.pathToReport);

                } else {

                    console.log("ERRO AO TRAZER PATH");
                    resolve(false);

                }
            }))

            pageIndex++;

            promises.push(new Promise(async (resolve, reject) => {
                let responsePart = await ReportAPI.getDistribuitionReportPartGrouped(clientOn.client,
                    period,
                    data[2],
                    data[3],
                    3, 4, pageIndex);

                if (responsePart.success) {

                    console.log("Resolvido 34");

                    resolve(responsePart.body.data.pathToReport);

                } else {

                    console.log("ERRO AO TRAZER PATH");
                    resolve(false);

                }
            }))

            pageIndex++;

            promises.push(
                new Promise(async (resolve, reject) => {
                    let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                        period,
                        data[4], 5, pageIndex);

                    if (responsePart.success) {

                        console.log("Resolvido 5");
                        resolve(responsePart.body.data.pathToReport);

                    } else {
                        resolve(false);
                    }
                })
            )

            promises.push(
                new Promise(async (resolve, reject) => {
                    let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                        period,
                        data[5], 6, pageIndex);

                    if (responsePart.success) {

                        console.log("Resolvido 5");
                        resolve(responsePart.body.data.pathToReport);

                    } else {
                        resolve(false);
                    }
                })
            )

            //Distribuições além das 6 originais (Vencimentos), uma página cada
            data.slice(6).forEach((part, index) => {
                promises.push(
                    new Promise(async (resolve, reject) => {
                        let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                            period,
                            part, 7 + index, pageIndex + 1 + index);

                        resolve(responsePart.success ? responsePart.body.data.pathToReport : false);
                    })
                )
            });

            responseParts = await Promise.all(promises);
        } else if (!group12 && group34) { //não agrupar o 1 e o 2 e agrupar o 3 e o 4

            let promises = [];

            const newData = data.slice(0, 2);

            newData.map(async (part, index) => {

                promises.push(
                    new Promise(async (resolve, reject) => {
                        let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                            period,
                            part, index + 1, pageIndex + index);

                        if (responsePart.success) {

                            resolve(responsePart.body.data.pathToReport);

                        } else {
                            resolve(false);
                        }
                    })
                )

            })

            pageIndex++;

            promises.push(new Promise(async (resolve, reject) => {
                let responsePart = await ReportAPI.getDistribuitionReportPartGrouped(clientOn.client,
                    period,
                    data[2],
                    data[3],
                    3, 4, pageIndex);

                if (responsePart.success) {

                    console.log("Resolvido 34");

                    resolve(responsePart.body.data.pathToReport);

                } else {

                    console.log("ERRO AO TRAZER PATH");
                    resolve(false);

                }
            }))

            pageIndex++;

            promises.push(
                new Promise(async (resolve, reject) => {
                    let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                        period,
                        data[4], 5, pageIndex);

                    if (responsePart.success) {

                        console.log("Resolvido 5");
                        resolve(responsePart.body.data.pathToReport);

                    } else {
                        resolve(false);
                    }
                })
            )

            promises.push(
                new Promise(async (resolve, reject) => {
                    let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                        period,
                        data[5], 6, pageIndex);

                    if (responsePart.success) {

                        console.log("Resolvido 5");
                        resolve(responsePart.body.data.pathToReport);

                    } else {
                        resolve(false);
                    }
                })
            )

            //Distribuições além das 6 originais (Vencimentos), uma página cada
            data.slice(6).forEach((part, index) => {
                promises.push(
                    new Promise(async (resolve, reject) => {
                        let responsePart = await ReportAPI.getDistribuitionReportPart(clientOn.client,
                            period,
                            part, 7 + index, pageIndex + 1 + index);

                        resolve(responsePart.success ? responsePart.body.data.pathToReport : false);
                    })
                )
            });

            responseParts = await Promise.all(promises);
        }

        console.log("Response partes: ", responseParts);

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);

        let responseReportFull = await
            ReportAPI.getDistribuitionReport(clientOn.client, responseParts, capaFileName);

        if (responseReportFull.success) {

            return responseReportFull.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getArticlesReportPath(startDate, endDate, reportCapaTitle) {

        let responseDataToReport = await getDataToArticleReport(clientOn.client, startDate, endDate);

        const period = getPeriodStringReport(startDate, endDate);

        let responseArticles = null;
        //Verificação de versão de RESOLUÇÃO

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
        console.log("ARTICLE REPORT: ", responseDataToReport);

        // Buscar dados de distribuição por enquadramento para a tabela com gráfico de pizza
        let distributionByDevice = null;
        try {
            let responseDistribution = await getDataToDistribuitionReport(
                clientOn.client.id,
                startDate,
                endDate,
                reportLoad.segregationSelected ? reportLoad.segregationSelected.value : null
            );
            if (responseDistribution.success && responseDistribution.dataToDistributionReport) {
                const deviceIndex = 1;
                const deviceData = responseDistribution.dataToDistributionReport[deviceIndex];

                if (deviceData) {
                    const dataToChart = {
                        chart: deviceData.dataToChart,
                    };
                    await saveChartImageToReport(
                        dataToChart,
                        'distribuition',
                        'chartDistributionArticles',
                        1,
                        legendPieChartOpts
                    );

                    distributionByDevice = deviceData.dataToTable;
                }
            }
        } catch (error) {
            console.log("Erro ao buscar dados de distribuição por enquadramento:", error);
        }

        //ALTERAR NOVA RESOLUTION
        if ((responseDataToReport.dataToArticlesReport[4]
            && responseDataToReport.dataToArticlesReport[5]
            && responseDataToReport.dataToArticlesReport[6]
            && responseDataToReport.dataToArticlesReport[7]
            && responseDataToReport.dataToArticlesReport[8]
            && responseDataToReport.dataToArticlesReport[9])

            || (responseDataToReport.dataToArticlesReport[11]
                && responseDataToReport.dataToArticlesReport[12]
                && responseDataToReport.dataToArticlesReport[13]
                && responseDataToReport.dataToArticlesReport[14]
                && responseDataToReport.dataToArticlesReport[15]
                && responseDataToReport.dataToArticlesReport[16])) {

            //V2 e V3
            responseArticles = await ReportAPI.getArticlesV2Report(
                clientOn.client,
                responseDataToReport.dataToArticlesReport,
                period, capaFileName,
                distributionByDevice
            );
        } else {
            //V1
            responseArticles = await ReportAPI.getArticlesReport(
                clientOn.client,
                responseDataToReport.dataToArticlesReport,
                period, capaFileName);
        }




        if (responseArticles.success) {

            return responseArticles.body.data.pathToReport;

        } else {

            return false;
        }

    }

    async function getTargetsReportPath(startDate, endDate, periodReport, reportCapaTitle, segregationCode) {
        let responseDataToReport = await getDataToTargetsReport(clientOn.client,
            startDate, endDate, periodReport, segregationCode);


        const period = getPeriodStringReport(startDate, endDate);

        if (responseDataToReport.success) {

            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
            let responseTargetsReport = await ReportAPI.getTargetsReport(
                clientOn.client,
                period,
                responseDataToReport.dataToReport, capaFileName);

            if (responseTargetsReport.success) {
                return responseTargetsReport.body.data.pathToReport;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    async function getMyFundsReportPath(startDate, endDate, periodReport, reportCapaTitle) {

        const segmentId = reportLoad.segmentId ? reportLoad.segmentId : 0;
        const accountRegimeId = reportLoad.segregationSelected ? reportLoad.segregationSelected.value : null;

        const period = getPeriodStringReport(startDate, endDate);

        //let responseDataToReport = await getDataToMyFundsReport(clientOn.client.id,
        let responseDataToReport = await getDataToMyFundsReport(
            clientOn.client,
            startDate,
            endDate,
            segmentId,
            periodReport,
            accountRegimeId,
            //Só a aba Meus fundos envia o toggle; demais fluxos (SelectPeriodReport) saem sem os resgatados
            reportLoad.includeRescuedFunds === true
        );

        console.log("DATA MY FUNDS REPORT: ", responseDataToReport);

        if (responseDataToReport.success) {

            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);

            let responseTargetsReport = await ReportAPI.getMyFundsReport(
                clientOn.client,
                period,
                responseDataToReport.dataToReport,
                periodReport, getMonthsPeriod(startDate, endDate), capaFileName);

            if (responseTargetsReport.success) {

                return responseTargetsReport.body.data.pathToReport;

            } else {

                return false;
            }


        } else {

            return false;

        }
    }

    async function getMyTitlesReportPath(startDate, endDate, reportCapaTitle) {
        let responseDataToReport = await getDataToMyTitlesReport(clientOn.client.id,
            startDate, endDate, reportLoad.accountRegimeId);

        const period = (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
            getPeriodStringReport(startDate, endDate);

        console.log("DATA MY TITLES REPORT: ", responseDataToReport);
        if (responseDataToReport.success && responseDataToReport.dataToReport.length == 0) {
            return NO_DATA;
        }

        if (responseDataToReport.success) {

            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);

            const responseMyTitlesReport = await ReportAPI.getMyTitlesReport(
                clientOn.client,
                period,
                responseDataToReport.dataToReport, capaFileName);

            if (responseMyTitlesReport.success) {

                return responseMyTitlesReport.body.data.pathToReport;

            } else {

                return false;
            }


        } else {

            return false;

        }
    }

    async function getRentsByClassReportPath(startDate, endDate, periodReport, reportCapaTitle) {
        let responseDataToReport = await getDataToRentsByClassReport(clientOn.client,
            startDate, endDate, periodReport);

        const period = getPeriodStringReport(startDate, endDate);

        console.log("DATA RENTS BY CLASS REPORT: ", responseDataToReport);
        if (responseDataToReport.success
            && responseDataToReport.dataToReport.dataToTable.length == 1
            && responseDataToReport.dataToReport.dataToTable[0].c1 == 'totalLine') {
            return NO_DATA;
        }

        if (responseDataToReport.success) {

            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);

            const fileChartName = "chartRentsByClass_" + new Date().getTime();
            await saveChartImageToReport(
                {
                    chart: responseDataToReport.dataToReport.dataToChart,
                },
                "distribuition", //mesmas options da distribuition
                fileChartName,
            );

            const responseRentsByClassReport = await ReportAPI.getRentsByClassReport(
                clientOn.client,
                period,
                responseDataToReport.dataToReport.dataToTable, fileChartName, capaFileName);

            if (responseRentsByClassReport.success) {

                return responseRentsByClassReport.body.data.pathToReport;

            } else {

                return false;
            }


        } else {

            return false;

        }
    }

    /**
     * @param {object} loadedData { rows, totalClientsNumber, filtersLabel } vindos da tela de ranking,
     * para o PDF sair com o mesmo recorte que está sendo exibido
     */
    async function getFundsRankingReportPath(loadedData, pageIndex = 1) {

        const responseFundsRankingReport = await getDataToFundsRankingReport(
            currentUser.user.consulting_id,
            loadedData);

        //Retorna null, e não FAILURE: FAILURE vale false, e o guard de quem chama é `!= null`,
        //que deixaria passar e abriria uma aba com URL inválida. Quem fecha o modal é o openReport,
        //então no caminho de erro o setReportLoad(null) precisa ser feito aqui.
        if (!responseFundsRankingReport.isSuccessful) {
            dispatch(allActions.reportLoadActions.setReportLoad(null))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao obter os dados do ranking de fundos"
            }))
            return null;
        }

        const dataToFundsRankingReport = responseFundsRankingReport.dataToFundsRankingReport;

        let dateNow = new Date();
        const period = getMonthName(dateNow.getMonth() + 1) + "/" + dateNow.getFullYear();
        const client = clientOn.client;

        let responseFundsRankingReportPath = await ReportAPI.getFundsRankingReport(
            client,
            period,
            dataToFundsRankingReport,
            pageIndex,
            loadedData && loadedData.filtersLabel ? loadedData.filtersLabel : null);

        if (responseFundsRankingReportPath.success) {
            const pathToReport = responseFundsRankingReportPath.body.data.pathToReport;
            return pathToReport;
        }
        else {
            dispatch(allActions.reportLoadActions.setReportLoad(null))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao gerar o relatório de ranking de fundos"
            }))
            return null;
        }
    }

    async function getDemonstrativeReportPath(startDate, endDate, loadedData, reportCapaTitle) {

        const responseDataToReport = await getDataToDemonstrativeReport(
            clientOn.client,
            clientOn.client.selectedPortfolioMonth,
            clientOn.client.selectedPortfolioYear,
            loadedData);
        // const responseDataToReport = {}
        // responseDataToReport.success = true;
        // //responseDataToReport.dataToReport = fundsTest;
        // responseDataToReport.dataToReport = fundsTest.slice(0, 3);
        // console.log("TO DEMONSTRATIVE REPORT: ", responseDataToReport);

        let index1 = 0;
        let index2 = 1;

        const countPages = responseDataToReport.dataToReport.length % 2 == 1 ? (responseDataToReport.dataToReport.length + 1) / 2 : responseDataToReport.dataToReport.length / 2;

        let finishedDemonstrativePages = 0;
        const demonstrativePromises = [];
        for (let index = 1; index <= countPages; index++) {

            const dataToReport = [
                responseDataToReport.dataToReport[index1],
                responseDataToReport.dataToReport[index2] ? responseDataToReport.dataToReport[index2] : null
            ]
            index1 += 2;
            index2 += 2;

            demonstrativePromises.push(
                await timeout(500)
            );
            demonstrativePromises.push(
                new Promise(async (resolve, reject) => {

                    const responseDemonstrativeReport = await ReportAPI.getDemonstrativeReport(
                        clientOn.client,
                        getMonthName(clientOn.client.selectedPortfolioMonth) + '/' + clientOn.client.selectedPortfolioYear,
                        dataToReport);

                    finishedDemonstrativePages++;

                    dispatch(allActions.reportLoadActions.setReportLoad({
                        show: true,
                        updateMessage: true,
                        message: 'Gerando demonstrativo... ( ' + Number.parseInt(finishedDemonstrativePages / countPages * 100) + '% )'
                    }))

                    if (responseDemonstrativeReport.success) {

                        resolve(responseDemonstrativeReport.body.data.pathToReport)

                    } else {

                        console.error("ERRO AO GERAR APR");
                        console.log("responseApr: ", responseDemonstrativeReport);
                        console.error("--------------");

                        resolve(false)

                    }

                })
            )

        }

        const pathsDemonstrative = await Promise.all(demonstrativePromises)

        //Retirando timeouts
        const realPaths = pathsDemonstrative.filter(el => el !== undefined && el !== null && el !== '');
        if (realPaths && realPaths.length === countPages) {


            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
            const responseFullDemonstrative = await ReportAPI.getFullDemonstrativeReport(clientOn.client, realPaths, capaFileName);

            if (responseFullDemonstrative.success) {

                Object.assign(document.createElement('a'), {
                    target: '_blank', href: REPORTS_URL + 'reports/'
                        + clientOn.client.id + responseFullDemonstrative.body.data.pathToReport
                }).click();

                dispatch(allActions.reportLoadActions.setReportLoad(null))

            } else {

                console.log("Erro ao gerar report apr 1");
                dispatch(allActions.reportLoadActions.setReportLoad(null))

            }

        } else {

            dispatch(allActions.reportLoadActions.setReportLoad(null))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Falha ao gerar demonstrativo',
                type: 'warning',
            }))
        }

    }

    async function getMyReturnsReportPath(startDate, endDate, reportCapaTitle) {
        let responseDataToReport = await getDataToMyClientReturns(clientOn.client.id, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear, reportLoad.accountRegimeId);

        if (responseDataToReport.isSuccessful) {
            const clientReturns = responseDataToReport.clientReturns;

            let period = (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
            getMonthName(clientOn.client.selectedPortfolioMonth) + "/" + clientOn.client.selectedPortfolioYear;

            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
            let responseTargetsReport = await ReportAPI.getMyReturnsReport(
                clientOn.client,
                period,
                clientReturns, capaFileName);

            if (responseTargetsReport.success) {
                return responseTargetsReport.body.data.pathToReport;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    async function getMyGlobalReturnsReportPath(startDate, endDate, reportCapaTitle) {
        const { success, data } = await getRawDataToTargetsReport(clientOn.client, reportLoad.accountRegimeId || 0);

        if (success) {

            const period = (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
            getMonthName(clientOn.client.selectedPortfolioMonth) + "/" + clientOn.client.selectedPortfolioYear;

            const formatToReport = (unformattedData) => {

                const formatted = [];
                unformattedData.forEach(row => {

                    const newRow = {
                        year: row.year,
                        targetLabel: `IPCA + ${applyMaskAmount(row.tax)}%`,
                        rows: [],
                        totalLine: {
                            rentMonth: applyMaskAmount(row.totalLine.rentAcumYear),
                            taxMonth: (row.totalLine.use_ipca ? applyMaskAmount(parseFloat(row.totalLine.taxAcumIpcaYear)) : applyMaskAmount(parseFloat(row.totalLine.taxtaxAcumInpcYear))),
                            gapMonth: (row.totalLine.use_ipca ? applyMaskAmount(parseFloat(row.totalLine.rentAcumYear - row.totalLine.taxAcumIpcaYear).toFixed(2)) : applyMaskAmount(parseFloat(row.totalLine.rentAcumYear - row.totalLine.taxtaxAcumInpcYear).toFixed(2)))
                        }
                    };

                    row.finalTargetsToShow.forEach(inflateMonth => {
                        newRow.rows.push(
                            inflateMonth ? {
                                rentMonth: applyMaskAmount(inflateMonth.rentPercent),
                                taxMonth: (inflateMonth.use_ipca ? applyMaskAmount(parseFloat(inflateMonth.taxMonthIpca)) : applyMaskAmount(parseFloat(inflateMonth.taxMonthInpc))),
                                gapMonth: (inflateMonth.use_ipca ? applyMaskAmount(parseFloat(inflateMonth.rentPercent - inflateMonth.taxMonthIpca).toFixed(2)) : applyMaskAmount(parseFloat(inflateMonth.rentPercent - inflateMonth.taxMonthInpc).toFixed(2)))
                            } : {
                                rentMonth: "-",
                                taxMonth: "-",
                                gapMonth: "-",
                            })
                    });
                    formatted.push(newRow)
                });

                return formatted;
            }


            const ensure12 = (arr, filler = null) => {
                return Array.from({ length: 12 }, (_, i) => arr[i] !== undefined ? arr[i] : filler);
            }

            data.forEach(row => {
                row.totalLine = row.finalTargetsToShow[row.finalTargetsToShow.length - 1];
                row.finalTargetsToShow = ensure12(row.finalTargetsToShow);
            });

            const formattedToReportData = formatToReport(data);

            console.log("formattedToReportData: ", formattedToReportData);


            const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
            const responseGlobalReturnsReport = await ReportAPI.getMyGlobalReturnsReport(
                clientOn.client,
                period,
                formattedToReportData, capaFileName);

            if (responseGlobalReturnsReport.success) {
                return responseGlobalReturnsReport.body.data.pathToReport;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    async function getMyReturnsByArticlesReportPath(startDate, endDate, loadedData, reportCapaTitle) {
        const period = (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
            getMonthName(clientOn.client.selectedPortfolioMonth) + "/" + clientOn.client.selectedPortfolioYear;

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
        const responseArticlesReturnsReport = await ReportAPI.getMyReturnsByArticlesReport(
            clientOn.client,
            period,
            loadedData, capaFileName);

        if (responseArticlesReturnsReport.success) {
            return responseArticlesReturnsReport.body.data.pathToReport;
        } else {
            return false;
        }
    }

    async function getMyReturnsByAssetsReportPath(startDate, endDate, loadedData, reportCapaTitle) {

        const period = (reportLoad.regimeLabel ? reportLoad.regimeLabel + ' - ' : '') +
            getMonthName(clientOn.client.selectedPortfolioMonth) + "/" + clientOn.client.selectedPortfolioYear;

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
        const responseGlobalReturnsReport = await ReportAPI.getMyReturnsByAssetsReport(
            clientOn.client,
            period,
            loadedData, capaFileName);

        if (responseGlobalReturnsReport.success) {
            return responseGlobalReturnsReport.body.data.pathToReport;
        } else {
            return false;
        }

    }

    async function getClientAccreditationProcessesReportPath(loadedData, reportCapaTitle) {

        const now = moment.utc(new Date());

        console.log("loadedData: ", loadedData);
        const period = getMonthName(parseInt(now.format("MM"))) + "/" + now.format("YYYY");

        const capaFileName = await getCapaFileNameIfNecessary(now.format("DD/MM/YYYY"), reportCapaTitle);
        const responseAccreditationProcessesReport = await ReportAPI.getClientAccreditationProcessesReport(
            clientOn.client,
            period,
            loadedData, capaFileName);

        if (responseAccreditationProcessesReport.success) {
            return responseAccreditationProcessesReport.body.data.pathToReport;
        } else {
            return false;
        }

    }

    async function getMyReturnsBySegregationReportPath(startDate, endDate, loadedData, reportCapaTitle) {

        const period = getMonthName(clientOn.client.selectedPortfolioMonth) + "/" + clientOn.client.selectedPortfolioYear;

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
        const responseSegregationReturnsReport = await ReportAPI.getMyReturnsBySegregationReport(
            clientOn.client,
            period,
            loadedData, capaFileName);

        if (responseSegregationReturnsReport.success) {
            return responseSegregationReturnsReport.body.data.pathToReport;
        } else {
            return false;
        }

    }

    async function getBenchmarkIndexesReportPath(startDate, endDate, loadedData, reportCapaTitle) {

        const period = getMonthName(clientOn.client.selectedPortfolioMonth) + "/" + clientOn.client.selectedPortfolioYear;

        const capaFileName = await getCapaFileNameIfNecessary(endDate, reportCapaTitle);
        const responseBenchmarkIndexesReport = await ReportAPI.getBenchmarkIndexesReport(
            clientOn.client,
            period,
            loadedData, capaFileName);

        if (responseBenchmarkIndexesReport.success) {
            return responseBenchmarkIndexesReport.body.data.pathToReport;
        } else {
            return false;
        }

    }

    async function getClientSuitabilityReportPath(selectedClient, suitabilityResponses) {
        const responseDataToReport = await getDataSuitabilityReport();

        if (responseDataToReport.success) {

            const responseReport = await ReportAPI.getSuitabilityReport(
                selectedClient,
                responseDataToReport.data,
                suitabilityResponses);

            if (responseReport.success) {
                Object.assign(document.createElement('a'), {
                    target: '_blank', href: REPORTS_URL + 'reports/' + selectedClient.id + '/suitabilities' + responseReport.body.data.pathToReport
                }).click();

                dispatch(allActions.reportLoadActions.setReportLoad(null))
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    async function getCompareFundsReportPath(funds, benchmarks, tablesData, returnsTableData) {
        const response = await ReportAPI.getCompareFundsReport(clientOn.client, funds, benchmarks, tablesData, returnsTableData);
        console.log('response PATH: ', response);

        if (response.success) {
            return response.body.data.pathToReport;
        } else {
            return false;
        }

    }

    async function getAprReportPath() {

        let responseDataToReport = await getDataToAprReport(reportLoad.aprId,
            clientOn.client.selectedPortfolioMonth,
            clientOn.client.selectedPortfolioYear, reportLoad.hideCpf);

        if (responseDataToReport.success) {

            let responseApr = await ReportAPI.getAprReport(
                clientOn.client,
                responseDataToReport.dataToReport);

            if (responseApr.success) {

                console.log("APR PATH: ", responseApr.body.data.pathAprReport);

                Object.assign(document.createElement('a'), {
                    target: '_blank', href: REPORTS_URL + 'reports/' + clientOn.client.id + '/aprs/' + responseApr.body.data.pathAprReport
                }).click();

                dispatch(allActions.reportLoadActions.setReportLoad(null))

            } else {

                console.log("Erro ao gerar report apr");
                dispatch(allActions.reportLoadActions.setReportLoad(null))

            }

        } else {

            console.log("Erro ao gerar report apr 2: ", responseDataToReport);
            dispatch(allActions.reportLoadActions.setReportLoad(null))
        }

    }

    async function getSingleAprReportPath() {

        let responseDataToReport = await getDataToSingleAprReport(reportLoad.aprId,
            clientOn.client.selectedAdministrativeMonth,
            clientOn.client.selectedAdministrativeYear, reportLoad.hideCpf);

        if (responseDataToReport.success) {

            let responseApr = await ReportAPI.getSingleAprReport(
                clientOn.client,
                responseDataToReport.dataToReport);

            if (responseApr.success) {

                Object.assign(document.createElement('a'), {
                    target: '_blank', href: REPORTS_URL + 'reports/' + clientOn.client.id + '/aprs/' + responseApr.body.data.pathAprReport
                }).click();

                dispatch(allActions.reportLoadActions.setReportLoad(null))

            } else {

                console.log("Erro ao gerar report apr");
                dispatch(allActions.reportLoadActions.setReportLoad(null))

            }

        } else {

            console.log("Erro ao gerar report apr 2: ", responseDataToReport);
            dispatch(allActions.reportLoadActions.setReportLoad(null))
        }

    }

    async function getBatchAprsReportPath() {

        let responseDataToReport = await getDataToBatchAprsReport(
            clientOn.client.id,
            clientOn.client.selectedPortfolioMonth,
            clientOn.client.selectedPortfolioYear,
            reportLoad.accountRegimeId,
            reportLoad.order,
            reportLoad.yearToSinglesAprs, reportLoad.hideCpf); //yearToSinglesAprs caso não seja nulo é referente a geração de lote das aprs avulsas

        console.log('responseDataToReport: ', responseDataToReport);

        if (responseDataToReport.success) {

            try {

                const aprsToGenerate = responseDataToReport.dataToReport;
                const countAprsToGenerate = aprsToGenerate.length;

                // Gera uma APR individual no backend, retornando { ok, path }.
                // Cada chamada abre um processo PhantomJS (html-pdf) no servidor,
                // por isso a concorrência é limitada abaixo.
                const generateApr = async (apr) => {
                    const responseApr = await ReportAPI.getAprReport(clientOn.client, apr);
                    if (responseApr.success && responseApr.body?.data?.pathAprReport) {
                        return { ok: true, path: responseApr.body.data.pathAprReport };
                    }
                    console.error("ERRO AO GERAR APR");
                    console.log("responseApr: ", responseApr);
                    console.log("apr: ", apr);
                    console.error("--------------");
                    return { ok: false, path: null };
                };

                // Pool de concorrência: no máximo CONCURRENCY APRs sendo geradas ao
                // mesmo tempo, evitando sobrecarregar o servidor (memória/CPU) com
                // dezenas de processos PhantomJS simultâneos.
                const CONCURRENCY = 3;
                const results = new Array(countAprsToGenerate);
                let finishedAprs = 0;
                let nextIndex = 0;

                const worker = async () => {
                    while (true) {
                        const index = nextIndex++;
                        if (index >= countAprsToGenerate) {
                            return;
                        }
                        results[index] = await generateApr(aprsToGenerate[index]);
                        finishedAprs++;
                        setInnerReportLoadMessage('Gerando lote de APRS... ( ' + Number.parseInt(finishedAprs / countAprsToGenerate * 100) + '% )');
                    }
                };

                await Promise.all(
                    Array.from({ length: Math.min(CONCURRENCY, countAprsToGenerate) }, () => worker())
                );

                // Apenas caminhos válidos (descarta falhas, que vêm como { ok: false }).
                const realPaths = results
                    .filter(el => el && el.ok && typeof el.path === 'string' && el.path !== '')
                    .map(el => el.path);

                console.log('countAprsToGenerate: ', countAprsToGenerate);
                console.log('realPaths: ', realPaths);

                if (realPaths.length === countAprsToGenerate) {

                    let responseBatchApr = await ReportAPI.getAprBatchReport(clientOn.client, realPaths);

                    if (responseBatchApr.success && responseBatchApr.body?.data?.pathToReport) {

                        console.log("RESPONSE BATCH: ", responseBatchApr);
                        Object.assign(document.createElement('a'), {
                            target: '_blank', href: REPORTS_URL + 'reports/'
                                + clientOn.client.id + responseBatchApr.body.data.pathToReport
                        }).click();

                        dispatch(allActions.reportLoadActions.setReportLoad(null))

                    } else {

                        console.log("Erro ao gerar report apr 1");
                        dispatch(allActions.reportLoadActions.setReportLoad(null))
                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            message: 'Falha ao unir as APRS em um único arquivo. Tente novamente.',
                            type: 'error',
                        }))

                    }

                } else {

                    // Falha parcial: não tenta o merge (resultaria em arquivo inválido/vazio).
                    const failedCount = countAprsToGenerate - realPaths.length;
                    dispatch(allActions.reportLoadActions.setReportLoad(null))
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        message: failedCount + ' de ' + countAprsToGenerate + ' APRS falharam na geração. Tente novamente.',
                        type: 'warning',
                    }))
                }

            } catch (error) {

                // Nunca deixar o loader travado caso algo lance inesperadamente.
                console.error("Erro inesperado na geração de lote de APRS: ", error);
                dispatch(allActions.reportLoadActions.setReportLoad(null))
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Falha ao gerar lote de APRS',
                    type: 'error',
                }))
            }

        } else {
            console.log("Erro ao gerar report apr 2");
            dispatch(allActions.reportLoadActions.setReportLoad(null))
        }

    }

    //Verifica se o report deve ou não ser incluido na geração
    function verifyIncludeReportType(reportTypeList, reportType, removeInFull) {

        if (reportTypeList == null) {
            if (removeInFull) {
                return false;
            } else {
                return true;
            }
        } else {
            return reportTypeList.includes(reportType);
        }

    }

    //Adicionando parametro reportTypeList, para caso de custom report
    async function getFullReportPath(dataDashboard,
        dataDistribuition,
        reportTypeList,
        startDate,
        endDate,
        periodReport, isCustom) {

        let promises = [];

        const isCustomReport = reportTypeList != null && reportTypeList.length > 0;

        console.log("reportTypeList: ", reportTypeList);

        const isIncludedDashboard = verifyIncludeReportType(reportTypeList, 'dashboard');
        const isIncludedPortfolio = verifyIncludeReportType(reportTypeList, 'portfolio');
        const isIncludedDistribuition = verifyIncludeReportType(reportTypeList, 'distribuition')
        const isIncludedArticles = verifyIncludeReportType(reportTypeList, 'articles')
        const isIncludedTargets = verifyIncludeReportType(reportTypeList, 'targets')
        const isIncludedMyFunds = verifyIncludeReportType(reportTypeList, 'myFunds')
        const isIncludedMyTitles = verifyIncludeReportType(reportTypeList, 'myTitles')
        const isIncludedAssetsAndAccounts = verifyIncludeReportType(reportTypeList, 'assetsAndAccounts', true)
        const isIncludedTransactionsInPeriod = verifyIncludeReportType(reportTypeList, 'transactionsInPeriod', true)
        const isIncludedRentsBySegment = verifyIncludeReportType(reportTypeList, 'rentsByClass')

        const reportTitle = isCustom ? "RELATÓRIO PERSONALIZADO" : "RELATÓRIO GERAL DE INVESTIMENTOS"
        const reportSubTitleArray = [];
        if (isCustom) {
            if (isIncludedDashboard) reportSubTitleArray.push("Dashboard")
            if (isIncludedPortfolio) reportSubTitleArray.push("Carteira")
            if (isIncludedDistribuition) reportSubTitleArray.push("Distribuição")
            if (isIncludedArticles) reportSubTitleArray.push("Enquadramentos")
            if (isIncludedTargets) reportSubTitleArray.push("Metas")
            if (isIncludedMyFunds) reportSubTitleArray.push("Análise de fundos")
            if (isIncludedMyTitles) reportSubTitleArray.push("Análise de títulos")
            if (isIncludedAssetsAndAccounts) reportSubTitleArray.push("Ativos e Contas")
            if (isIncludedTransactionsInPeriod) reportSubTitleArray.push("Movimentações no período")
            if (isIncludedRentsBySegment) reportSubTitleArray.push("Rentabilidades por classe")
        }

        //Adicionando capa
        promises.push(
            new Promise(async (resolve, reject) => {
                let path = await getCapaReportPath(startDate, endDate, reportTitle, periodReport,
                    reportSubTitleArray.length ? reportSubTitleArray.join(", ") : null);

                if (path) {

                    resolve({
                        path,
                        index: 0,
                    });

                } else {

                    resolve(false);

                }
            })
        )

        if (isIncludedDashboard) {
            //DASHBOARD
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getDashboardReportPath(dataDashboard, startDate, endDate);

                    if (path) {

                        resolve({
                            path,
                            index: 2,
                        });

                    } else {

                        resolve(false);

                    }
                })
            )
        }


        if (isIncludedPortfolio) {
            //PORTFOLIO
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getPortfolioReportPath(null, startDate, endDate, periodReport, {});

                    if (path) {

                        resolve({
                            path,
                            index: 1,
                        });

                    } else {

                        resolve(false);

                    }
                })
            )
        }

        if (isIncludedDistribuition) {
            //DISTRIBUITION
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getDistribuitionReportPath(dataDistribuition, startDate, endDate);

                    if (path) {

                        resolve({
                            path,
                            index: 3,
                        });

                    } else {

                        resolve(false);

                    }
                })
            )
        }

        if (isIncludedArticles) {
            //ARTICLES
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getArticlesReportPath(startDate, endDate);

                    if (path) {

                        resolve({
                            path,
                            index: 4,
                        });

                    } else {

                        resolve(false);

                    }
                })
            )
        }

        if (isIncludedTargets) {
            //TARGETS
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getTargetsReportPath(startDate, endDate, periodReport, "", 0);

                    if (path) {

                        resolve({
                            path,
                            index: 5,
                        });

                    } else {
                        resolve(false);
                    }
                })
            )
        }

        if (isIncludedMyFunds) {
            //MYFUNDS
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getMyFundsReportPath(startDate, endDate, periodReport);

                    if (path) {
                        resolve({
                            path,
                            index: 6,
                        });
                    } else {
                        resolve(false);
                    }
                })
            )
        }

        if (isIncludedRentsBySegment) {
            //RENTS BY CLASS
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getRentsByClassReportPath(startDate, endDate, periodReport);

                    if (path == NO_DATA) {
                        resolve(NO_DATA);
                    }

                    if (path) {
                        resolve({
                            path,
                            index: 7,
                        });
                    } else {
                        resolve(false);
                    }
                })
            )
        }

        if (isIncludedMyTitles) {
            //MYFUNDS
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getMyTitlesReportPath(startDate, endDate);

                    if (path == NO_DATA) {
                        resolve(NO_DATA);
                    }

                    if (path) {
                        resolve({
                            path,
                            index: 8,
                        });
                    } else {
                        resolve(false);
                    }
                })
            )
        }

        if (isIncludedAssetsAndAccounts) {
            //PORTFOLIO
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getPortfolioReportPath(null, startDate, endDate, periodReport, {
                        isAssetAndAccountsReport: true
                    });

                    if (path) {

                        resolve({
                            path,
                            index: 9,
                        });

                    } else {

                        resolve(false);

                    }
                })
            )
        }

        if (isIncludedTransactionsInPeriod) {
            //PORTFOLIO
            promises.push(
                new Promise(async (resolve, reject) => {
                    let path = await getPortfolioReportPath(null, startDate, endDate, periodReport, {
                        isAccumulatedTrasactionsReport: true
                    });

                    if (path) {

                        resolve({
                            path,
                            index: 10,
                        });

                    } else {

                        resolve(false);

                    }
                })
            )
        }



        let responseAll = await Promise.all(promises);
        let pathsToSend = [];

        console.log("RESPONSE ALL: ", responseAll);

        if ((responseAll.filter(el => !el)).length == 0) {

            for (let i = 0; i < responseAll.length; i++) {

                if (responseAll[i] != NO_DATA) {//removendo os que não possuem dados, como no caso em que não há títulos

                    pathsToSend.push(responseAll[i].path);

                }

            }

            if (pathsToSend.length == 1) {
                //Indica que apenas a capa foi gerada então não é gerado o report
                dispatch(allActions.reportLoadActions.setReportLoad(null))
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: "Não existem informações suficientes para gerar o relatório",
                    type: 'warning',
                }))
            } else {

                let responseFullReport = await ReportAPI.getFullReport(clientOn.client, pathsToSend, isCustomReport);

                if (responseFullReport.success) {
                    return responseFullReport.body.data.pathToReport
                } else {
                    return false;
                }
            }

        } else {
            console.error("EXISTE PELO MENOS UM PATH INVALIDO: ", responseAll);
            dispatch(allActions.reportLoadActions.setReportLoad(null))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao gerar relatório",
                type: 'error',
            }))
        }
    }

    async function getSegregationReportPath(
        segregationSelected,
        dataDistribuition,
        startDate,
        endDate,
        periodReport) {

        const promises = [];

        //Adicionando capa
        promises.push(
            new Promise(async (resolve, reject) => {
                let path = await getCapaReportPath(startDate, endDate, `RELATÓRIO POR SEGREGAÇÃO (${segregationSelected.name})`, periodReport);

                if (path) {

                    resolve({
                        path,
                        index: 0,
                    });

                } else {

                    resolve(false);

                }
            })
        )
        //PORTFOLIO
        promises.push(
            new Promise(async (resolve, reject) => {
                let path = await getPortfolioReportPath(segregationSelected.value, startDate, endDate, periodReport, {});

                if (path) {

                    resolve({
                        path,
                        index: 1,
                    });

                } else {

                    resolve(false);

                }
            })
        )



        //DISTRIBUITION
        promises.push(
            new Promise(async (resolve, reject) => {
                let path = await getDistribuitionReportPath(dataDistribuition, startDate, endDate);

                if (path) {

                    resolve({
                        path,
                        index: 3,
                    });

                } else {

                    resolve(false);

                }
            })
        )

        //TARGETS
        promises.push(
            new Promise(async (resolve, reject) => {
                let path = await getTargetsReportPath(startDate, endDate, periodReport, "", segregationSelected.value);

                if (path) {

                    resolve({
                        path,
                        index: 3,
                    });

                } else {

                    resolve(false);

                }
            })
        )

        const responseAll = await Promise.all(promises);
        const pathsToSend = [];

        console.log("RESPONSE ALL: ", responseAll);

        if ((responseAll.filter(el => !el)).length == 0) {

            for (let i = 0; i < responseAll.length; i++) {

                if (responseAll[i] != NO_DATA) {//removendo os que não possuem dados, como no caso em que não há títulos

                    pathsToSend.push(responseAll[i].path);

                }

            }

            const responseSegregationReport = await ReportAPI.getFullReport(clientOn.client, pathsToSend, false, 'RELATORIO_POR_SEGREGACAO');

            if (responseSegregationReport.success) {
                return responseSegregationReport.body.data.pathToReport
            } else {
                return false;
            }
        } else {
            console.error("EXISTE PELO MENOS UM PATH INVALIDO: ", responseAll);
            dispatch(allActions.reportLoadActions.setReportLoad(null))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao gerar relatório",
                type: 'error',
            }))
        }
    }

    useEffect(() => {

        if (reportLoad) {
            //Em caso de apeans atualização de mensagem não se dispara o generate
            if (!reportLoad.updateMessage) {
                console.log('reportLoad: ', reportLoad);

                //testReport();
                //Sem o catch, qualquer erro na geração deixaria o modal "Gerando relatório..."
                //aberto indefinidamente, sem mensagem para o usuário
                prepareChartsAndGenerate(reportLoad).catch(error => {
                    console.error("FALHA AO GERAR RELATÓRIO: ", error);
                    dispatch(allActions.reportLoadActions.setReportLoad(null))
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        message: "Falha ao gerar relatório",
                        type: 'error',
                    }))
                });
            }
        }

    }, [reportLoad]);

    return (
        <Dialog
            open={reportLoad && reportLoad.show}
            fullWidth={true}
            maxWidth={modalWidth == 'big' ? false : 'sm'}>
            <DialogContent className={classes.root} style={
                modalWidth == 'big' ? {
                    width: '1180px',
                    textAlign: 'center',
                    margin: '0 auto',
                    paddingTop: '40px',
                    paddingBottom: '40px',
                    pointerEvents: 'none',
                } : {}}>

                {
                    dataToDistribuitionChart ?
                        <div className={classes.displayChart}>

                            <Pie data={dataToDistribuitionChart}
                                legend={legendPieChartOpts}
                                options={{
                                    tooltips: {
                                        enabled: false
                                    },
                                    animation: {
                                        duration: 500
                                    },
                                    responsive: true,
                                    //maintainAspectRatio: false,
                                }}
                                plugins={chartPlugins}
                                ref={chartDistribuitionRef} />

                        </div > : null
                }

                {
                    dataToEvolutionPlChart ?
                        <div className={classes.displayChart}>

                            <Bar data={dataToEvolutionPlChart}
                                options={optionsEvolutionChart}
                                plugins={chartPlugins}
                                ref={chartEvolutionPlRef} />

                        </div> : null
                }

                {
                    dataToCompareChart ?
                        <div className={classes.displayChart}>

                            <Bar data={dataToCompareChart}
                                options={optionsCompareChart}
                                plugins={chartPlugins}
                                ref={chartCompareRef}
                            />

                        </div> : null
                }

                {
                    dataToRentsMonthCompareFundsChart ?
                        <div className={classes.displayChartCompareFunds}>

                            <Bar data={dataToRentsMonthCompareFundsChart}
                                options={optionsChartRentsMonthCompareFunds}
                                plugins={chartPlugins}
                                ref={chartRentsMonthCompareFundsRef}
                            />

                        </div> : null
                }

                {
                    dataToPlEvolutionCompareFundsChart ?
                        <div className={classes.displayChartCompareFunds}>

                            <Bar data={dataToPlEvolutionCompareFundsChart}
                                options={optionsChartPlEvolutionCompareFunds}
                                plugins={chartPlugins}
                                ref={chartPlEvolutionCompareFundsRef}
                            />

                        </div> : null
                }

                <div className={classes.progressAndMessage}>
                    <CircularProgress disableShrink />
                    <Typography variant={"h6"} align={"center"}>
                        {innerReportLoadMessage ? innerReportLoadMessage : (reportLoad && reportLoad.message)}
                    </Typography>
                </div>


            </DialogContent >
        </Dialog >
    );
}

